/**
 * Setup all sounds for user interface
 */

import { $onWithUnsubscribe } from "./event-bus";
import { useStore } from "../stores"

var audioElement = null
var soundsCallbacks = []

/**
 * Play the sound
 * 
 * @param soundFile name of the sound file
 */
function playSound(soundFile: string){
	audioElement.src = '/sounds/' + soundFile
	audioElement
		.play()
		.catch(() => {}) // Silence possible JS Exceptions like "The play() request was interrupted by a new load request. https://goo.gl/LdLk22"
}

/**
 * Initialize sound event handlers
 * @param domElement if not provided, try to reuse the previous one
 */
export function initSounds(domElement: HTMLAudioElement){
	if(!audioElement)	audioElement = domElement
	
	const store = useStore()

	// Sync store value with the local storage since it is the source of truth
	let value = !!window.localStorage.getItem('soundsMuted')
	store.settings.soundsMuted = !!value

	// Setup handlers once, if sounds are enabled and not muted by the client
	if(store.settings.ui.soundsEnabled && !store.settings.soundsMuted){
		soundsCallbacks.push($onWithUnsubscribe('challenge-completed', () => playSound("challenge-completed.mp3")))
		soundsCallbacks.push($onWithUnsubscribe('promo-code-applied', () => playSound("promo-code-applied.mp3")))
		soundsCallbacks.push($onWithUnsubscribe('challenge-failed', () => playSound("challenge-failed.mp3")))
		soundsCallbacks.push($onWithUnsubscribe('challenge-snoozed', () => playSound("challenge-snoozed.mp3")))
		soundsCallbacks.push($onWithUnsubscribe('achievement-collected', () => playSound("achievement-collected.mp3")))
		soundsCallbacks.push($onWithUnsubscribe('favourites-updated', () => playSound("favourites-updated.mp3")))
		soundsCallbacks.push($onWithUnsubscribe('reward-created', () => playSound("reward-created.mp3")))
		soundsCallbacks.push($onWithUnsubscribe('points-transferred1', () => playSound("points-transferred.mp3")))
	}
}

/**
 * Set sounds muted by storing the flag in the localStorage
 * @param value `true` - mute sounds, `false` - unmute sounds
 */
export function setMuteSounds(value: boolean){
	window.localStorage.setItem('soundsMuted', value ? "1" : '')

	// Update the value in store for the reactivity
	const store = useStore()
	store.settings.soundsMuted = !!value

	if(!value){
		// If the user is unmuting, lets try to initialize sounds
		initSounds(audioElement)
	}else{
		// Unsubscribe from all sound related bus events
		soundsCallbacks = soundsCallbacks.filter(item => {
			item()
			return false;
		})
	}
}